module.exports = __webpack_public_path__ + "img/2157.d58e37ee.gif";